<template>
  <Heatmap />
  <ScaleLegend />
</template>

<script>
import Heatmap from './components/Heatmap.vue'
import ScaleLegend from './components/ScaleLegend.vue';

export default {
  name: 'App',
  components: {
    Heatmap,
    ScaleLegend
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  display:block;
  height: auto;
}
</style>
